var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LabelAndMessage',{scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('IxRes',[_vm._v("Areas.FieldRecordSystem.SR_FieldRecordSystem.ProtectionProduct")])]},proxy:true}])},[_c('div',[_vm._v(_vm._s(_vm.productName))])])}
var staticRenderFns = []

export { render, staticRenderFns }